import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { TestSubsection } from "./TestSection";
import { User, Settings as SettingsIcon, Calendar as CalIcon, Webhook, Key, Activity } from "lucide-react";
import * as tests from "./testDefinitions";

export const SettingsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">⚙️ Settings</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={User}
          iconColor="text-blue-600"
          title="Profile"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.profileTests}
          results={testResults.profile}
        />
        
        <TestSubsection
          icon={SettingsIcon}
          iconColor="text-gray-600"
          title="Preferences"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.preferencesTests}
          results={testResults.preferences}
        />
        
        <TestSubsection
          icon={CalIcon}
          iconColor="text-purple-600"
          title="Calendar"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.calendarTests}
          results={testResults.calendar}
        />
        
        <TestSubsection
          icon={Webhook}
          iconColor="text-indigo-600"
          title="Webhooks"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.webhooksTests}
          results={testResults.webhooks}
        />
        
        <TestSubsection
          icon={Key}
          iconColor="text-yellow-600"
          title="API Keys"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.apiKeysTests}
          results={testResults.apiKeys}
        />
        
        <TestSubsection
          icon={Activity}
          iconColor="text-green-600"
          title="Activity Log"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.activityLogTests}
          results={testResults.activityLog}
        />
      </CardContent>
    </Card>
  );
};
